import { Component } from '@angular/core';
import LogRocket from 'logrocket';
import { WorkerService } from "app/core/solar/worker.service";
import {
    OnPageVisible, OnPageHidden,
    OnPageVisibilityChange,
    AngularPageVisibilityStateEnum,
    OnPagePrerender, OnPageUnloaded} from 'angular-page-visibility';
import { WebsocketService } from './core/solar/websocket.service';
import { AuthService } from './core/auth/auth.service';
import { switchMap } from 'rxjs';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
        private _serviceWorker: WorkerService, 
        private _websocketService: WebsocketService,
        private _authService: AuthService
    )
    {
        LogRocket.init('o0sm4m/solarapp');
        this._serviceWorker.$isAnyNewUpdateAvailable.subscribe((versionAvailableFlag: boolean) => {
            console.log("app.component versionAvailable", versionAvailableFlag);
        });    
    }

    @OnPageVisible()
    logWhenPageVisible (): void {
        console.log( 'OnPageVisible => visible' );

        this._authService.check().pipe(
            switchMap(async isSessionValid => {
              if (!isSessionValid) {
                this._authService.signOut();
                location.reload();
              }
            })
        );

        this._websocketService.onPageVisible();
        this._serviceWorker.checkNewVersionUpdate();
    }

    @OnPageHidden()
    logWhenPageHidden (): void {
        console.log( 'OnPageHidden => hidden' );
        this._websocketService.onPageHidden();
    }

    @OnPagePrerender()
    logWhenPagePrerender (): void {
        console.log( 'OnPagePrerender => prerender' );
    }

    @OnPageUnloaded()
    logWhenPageUnloaded (): void {
        console.log( 'OnPageUnloaded => unloaded' );
    }

    @OnPageVisibilityChange()
    logWhenPageVisibilityChange ( visibilityState: AngularPageVisibilityStateEnum ): void {
        if ( AngularPageVisibilityStateEnum[visibilityState]
        === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.VISIBLE]) {
        console.log( 'OnPageVisibilityChange => visible' );
        } else if (AngularPageVisibilityStateEnum[visibilityState]
        === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.HIDDEN]) {
        console.log( 'OnPageVisibilityChange => hidden' );
        } else if (AngularPageVisibilityStateEnum[visibilityState]
        === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.PRERENDER]) {
        console.log( 'OnPageVisibilityChange => prerender' );
        } else if (AngularPageVisibilityStateEnum[visibilityState]
        === AngularPageVisibilityStateEnum[AngularPageVisibilityStateEnum.UNLOADED]) {
        console.log( 'OnPageVisibilityChange => unloaded' );
        }
    }
}